import React from "react";

import deleteIcon from "images/icons/invite/delete.svg";

import { useTeamTopicContext } from "../../../../contexts/TeamTopicContext";

export default function Actions({ row }) {
  const { dispatch, state, actions } = useTeamTopicContext();

  const deleteTopic = (e, row) => {
    swal(
      {
        title: "",
        text: "Do you want to remove this topic from the team?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.removeTopic(dispatch, state.team, row.id, function () {
            actions.loadTopics(dispatch, state.team);
          });
        }
      }
    );
  };

  return (
    <div>
      <a onClick={(e) => deleteTopic(e, row)}>
        <img src={deleteIcon} />
      </a>
    </div>
  );
}
